export const FEATURE_TAB_UPDATE_UNIT_REQUEST = "FEATURE_TAB_UPDATE_UNIT_REQUEST";
export const FEATURE_TAB_UPDATE_UNIT_RESULT = "FEATURE_TAB_UPDATE_UNIT_RESULT";

export const FEATURE_TAB_OPEN_MODAL= "FEATURE_TAB_OPEN_MODAL";
export const FEATURE_TAB_CLOSE_MODAL= "FEATURE_TAB_CLOSE_MODAL";

export const FEATURE_TAB_GET_DEVICE_REQUEST = "FEATURE_TAB_GET_DEVICE_REQUEST";
export const FEATURE_TAB_GET_DEVICE_RESULT = "FEATURE_TAB_GET_DEVICE_RESULT";
